import React, { useState } from "react";
import { PieChart } from "react-minimal-pie-chart";

const TotalRevenue = ({ transactions }) => {
  const [hovered, setHovered] = useState(null);

  // Convert values to numbers
  const cash = parseFloat(transactions.cash) || 0;
  const card = parseFloat(transactions.card) || 0;
  const upi = parseFloat(transactions.upi) || 0;
  const due = parseFloat(transactions.due) || 0;

  const totalRevenue = cash + card + upi + due || 1; // Prevent division by zero

  // Pie Chart Data
  const data = [
    { title: "Cash", value: cash, color: "#5856D6" },
    { title: "Card", value: card, color: "#F44771" },
    { title: "UPI", value: upi, color: "#30B0C7" },
    { title: "Due", value: due, color: "#FF9500" },
  ];

  return (
    <div className="bg-white rounded-2xl p-4 flex flex-col items-center relative">
      <h1 className="text-G800 text-lg sm:text-xl font-semibold mb-4">
        Total Revenue
      </h1>

      {/* Pie Chart */}
      <div className="relative w-[120px] lg:w-[140px] xl:w-[160px]">
        <PieChart
          data={data}
          radius={42}
          lineWidth={40}
          background="#F4FDF6"
          onMouseOver={(_, index) => setHovered(index)}
          onMouseOut={() => setHovered(null)}
        />

        {/* Tooltip */}
        {hovered !== null && (
          <div
            className="absolute bg-gray-800 text-white text-xs px-2 py-1 rounded"
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              whiteSpace: "nowrap",
              pointerEvents: "none",
            }}
          >
            {data[hovered].title}: {Math.round((data[hovered].value / totalRevenue) * 100)}%
          </div>
        )}
      </div>

      {/* Legend */}
      <div className="flex space-x-5 mt-6">
        {data.map((item, index) => (
          <div key={index} className="flex items-center space-x-1">
            <div
              className="w-[10px] h-[10px]"
              style={{ backgroundColor: item.color }}
            ></div>
            {/* <span className="text-sm">{item.title}</span> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TotalRevenue;

